import { formatCount } from "@/lib/format";

/**
 * The count on a filter chip, once it is known. Until then, `reserve`
 * characters of blank space hold its place, so the chips do not widen,
 * and the row wrap and push the page down, when the counts land.
 */
export default function FilterCount({
    value,
    tone,
    reserve = 0,
}: {
    value: number | undefined;
    tone: string;
    reserve?: number;
}) {
    if (value === undefined) {
        if (reserve === 0) return null;
        return (
            <span
                aria-hidden="true"
                className="inline-block font-mono text-[11px]"
                style={{ width: `${reserve}ch` }}
            />
        );
    }
    return <span className={`font-mono text-[11px] ${tone}`}>{formatCount(value)}</span>;
}
